module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABPklEQVR4Ae2YNUIEQRBFuQB2Aw6CZDgngAuQcQjc4QrrLt00ISkW4a4p7g79mdpo3WUqeLsjf6reuFS1DXSXNCyYDBa0uuWQ1S3uNL9xeNBMFUXQ4RFNJJEUm1u1FFzQ5ha9RnO5bpOyPhaYhwyyRRPUu3klwSGwYk5Bm1uO6uKbiRGXdIy9JMi8UOYyWT30TEfwGIULCXqmLBgILNXhLKUzdSePYjuRPuiZXDDBcZQHYh2/LPgOSlXwyxFYbAAYLkXB68gyGE6cZUG5gnutHh5PQXDcyMqVwgl6xPz/PM9CRzJBZIysmC8RQRZkQRYEYXpo7U8miAxNCxdSEBxqPpMJUuawFO4k70qpGoDhUn2aOQHl9jzIgv48CvqzFrR5VU++BFE7a0Fg98g+erv7zoEYauygZqV/fmNBFmTBP4xN9dpGKmpLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/b1_delete@2x.png
// module id = 20Ku
// module chunks = 1